import { AWS_CLOUD_FRONT_TRAINING_URL } from 'modules/aws/constants/cloud-front/training'
import getImagePlanUtil from 'modules/training/models/plan/utils/get-image'
import { getImageUriPlanUtil } from '@gymaholic/packages'

function getImageUrlPlanUtil (instance) {
  const image = getImagePlanUtil(instance)
  if (!image) {
    return `${AWS_CLOUD_FRONT_TRAINING_URL}/assets/gymaholic.jpg`
  }

  return AWS_CLOUD_FRONT_TRAINING_URL + `/${getImageUriPlanUtil(instance)}`
}

export default getImageUrlPlanUtil
